import styled, {css} from 'styled-components'

const Style = {
	Header: styled.header`
		width: 100%;
		height: 80px;
		display: flex;
		align-items: center;
		position: relative;
		box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
		z-index: 1;

		${({$login}) =>
			$login
				? css`
						justify-content: space-between;
						padding: 0 65px;

						@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
							padding: 0 20px;
							justify-content: space-between;
						}
				  `
				: css`
						justify-content: center;
				  `};
	`,
	LogoImg: styled.img`
		width: 117px;
	`,

	DownloadButtonContainer: styled.div`
		display: flex;
		align-items: center;

		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			display: none;
		}
	`,

	ProfileDiv: styled.div`
		width: fit-content;
		display: flex;
		flex-direction: column;
		align-items: end;

		& > p {
			color: ${({theme}) => theme.color.grey4};
			${({theme}) => theme.font.small};
		}

		& > h2 {
			${({theme}) => theme.font.medium_bold};
		}

		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			display: none;
		}
	`,

	MobileButtonsContainer: styled.div`
		display: none;
		gap: 8px;

		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			display: flex;
			align-items: center;
			justify-content: center;
			width: fit-content;
		}
	`,

	MobileMenuButton: styled.button`
		display: flex;
		background: none;
		border: none;
		cursor: pointer;
		padding: 8px;
		border-radius: 4px;
		transition: background-color 0.2s ease;
		align-items: center;
		justify-content: center;

		&:hover {
			background-color: ${({theme}) => theme.color.grey1};
		}

		img {
			width: 24px;
			height: 24px;
		}
	`,

	HamburgerIcon: styled.div`
		width: 24px;
		height: 2px;
		background-color: ${({theme}) => theme.color.black};
		position: relative;
		transition: all 0.3s ease;

		&::before,
		&::after {
			content: '';
			position: absolute;
			width: 100%;
			height: 2px;
			background-color: ${({theme}) => theme.color.black};
			transition: all 0.3s ease;
		}

		&::before {
			top: -8px;
		}

		&::after {
			top: 8px;
		}
	`,

	// "HorDiv": styled.div`
	//     display: flex;
	//     flex-direction: row;
	//     align-items: center;
	// `,
	// "TabNameLabel": styled.h2`
	//     ${({ theme }) => theme.font.medium_bold}
	//     margin-left: 55px;
	// `,
	// "NicknameLabel": styled.p`
	//     ${({ theme }) => theme.font.medium_bold}
	//     white-space: nowrap;
	//     span {
	//         ${({ theme }) => theme.font.medium_bold}
	//         color: ${({ theme }) => theme.color.major}
	//     }
	// `,
}

export default Style
